<h3 style="font-family: 'Noto Sans JP', sans-serif; color: #E0FFFF; margin-top: 2%; margin-bottom: 1%; margin-right: 2%;">
   <b>Ciao, benvenuto nel mio sito!</b>
  </h3>

 <p class="mission" >
    Ne approfitto per presentarmi, mi chiamo Giovanni Sulli classe 95,
    sportivo in ambito fitness e bodybuilding da diversi anni e Personal Trainer riconosciuto CONI
    qualificato con diploma CSEN e Laureando in Scienze Motorie.
  <p>
  <p class="mission">
  La mia missione è indirizzarti in una visione ampia di ciò che è lo sport ed uno stile di vita sano, creando un
  percorso fitness da seguire insieme che miri principalmente al benessere fisico e mentale.
  Per esperienza personale capisco benissimo che non è affatto facile intraprendere uno stile di vita diverso
  dalla tua zona di confort, ma io sono qui, cercherò di farti avere una nuova visione di ciò che è lo sport ed il benessere.
  Lotto ogni giorno per far capire a tutti coloro che attuano il mio approccio, che la palestra o sport in generale non è il luogo dove si spingono solo pesi o si fatica senza pietà, bensì un luogo dove ci si prende cura di se stessi, si lavora per la propria salute e crea una valvola di sfogo dalla routine quotidiana che ci assale, chiave fondamentale del tuo successo e del tuo benessere fisico e psicofisico.
  Il percorso che attueremo io e te sarà una frequenza che percorrerà la stessa onda radio, nessuno dei due può mollare, i risultati estetici e salutistici che potrai notare nelle mie pagine, sono frutto di un lavoro in sinergia tra le parti, solo così avremo il cambiamento a 360°.
  Lieto di accoglierti nel mio team, ti aspetto!
  </p>

<HR>
<h1 align="center" style="font-family: 'Josefin Sans', sans-serif; font-size:30px; color: #E0FFFF; margin-top: 2%; margin-bottom: 1%; margin-right: 2%;"><b>ENTRA ANCHE TU A FAR PARTE DELLA BODY REVOLUTION</b></h1>
<h3 style="font-family: 'Josefin Sans', sans-serif; color: #E0FFFF; margin-top: 2%; margin-bottom: 1%; margin-right: 2%;"><b>IL SERVIZIO DI COACHING ONLINE CREATO DA ME PER FAR Sì CHE TI POSSA AIUTARE ANCHE A DISTANZA NEL RAGGIUNGIMENTO DELL’OBIETTIVO DA TE DESIDERATO.</b></h3>


<h1 style="margin-top: 6%; color: #E0FFFF;  font-family: 'Josefin Sans', sans-serif;  font-size: 30px;"><b>A CHI E' RIVOLTO BODY REVOLUTION?</b></h1>

<div class="row">
    <div class="col-xs-12 col-sm-8 col-md-8">
        <p class="mission">
        SI RACCOMANDA L’ISCRIZIONE AI SERVIZI DI COACHING ONLINE SOLO A SOGGETTI CON BUONA CONOSCENZA DELLA SALA PESI,
            QUINDI NON NEOFITI O PRINCIPIANTI, IN QUANTO VISTA LA MIA NON PRESENZA
            SUL CAMPO DURANTE I VOSTRI ALLENAMENTI, RISULTEREBBE COMPLICATO PARTIRE DALLE BASI.
            <br>
            INOLTRE E' CONSIGLIATA UN BUONA CONOSCENZA DI APP CONTACALORIE IN MODO DA SAPER GESTIRE I VARI CONSIGLI ALIMENTARI FORNITI.
<br>
            PRIMA DI ACQUISTARE UN SERVIZIO, POTRETE TRANQUILLAMENTE CONTATTARMI PER CAPIRE INSIEME QUALE SIA IL PERCORSO PIU’ IDONEO PER POTER PARTIRE INSIEME.
            <br>
        IL SERVIZIO DI COACHING ONLINE E’ DISPONIBILE ANCHE PER PROTOCOLLI CASALINGHI.
        LIETO DI ACCOGLIERVI NEL MIO TEAM, VI RINGRAZIO PER LA COLLABORAZIONE.
        </p>
        <h1 style="margin-top: 6%; color: #E0FFFF;  font-family: 'Josefin Sans', sans-serif;  font-size: 30px;"><b>PERCHE’ SCEGLIERE UN PROTOCOLLO BODY REVOLUTION?</b></h1>
        <p class="mission">
        BODY REVOLUTION NASCE CON L’INTENZIONE DI SODDISFARE LE ESIGENZE DI COLORO CHE ANCHE A DISTANZA VOGLIONO METTERSI IN GIOCO E SONO LIETI DI ATTUARE I MIEI PROTOCOLLI D’ALLENAMENTO.
            <br>
        IL MIO IMPEGNO SARA’ QUELLO DI GARANTIRE IL MASSIMO SUPPORTO E LA MASSIMA PROFESSIONALITA’ ANCHE A DISTANZA, RIMANENDO IN CONTATTO PERIODICO PER QUALUNQUE DELUCIDAZINE O “PROBLEMATICA” SI CREI.
            <br>
        NEI BOX BODY REVOLUTION CHE ANDRETE A SCEGLIERE SARANNO INSERITI TUTTI I SERVIZI CHE VI SARANNO FORNITI.
            <br>
        UNA VOLTA ACQUISTATO IL BOX DA VOI SCELTO, VI CONTATTERO’ ENTRO TRE GIORNI PER FISSARE LA VIDEOCHIAMATA CONOSCITIVA ED EFFETTUARE L’ANAMENSI CHE MI PERMETTERA’ DI CREARE IL PROTOCOLLO ADATTO ALLE TUE ESIGENZE.
        </p>
       <h1 style="margin-top: 6%; color: #E0FFFF;  font-family: 'Josefin Sans', sans-serif;  font-size: 30px;"><b>VAI NELLA SEZIONE SERVIZI E SCOPRI DI PIU!</b></h1>

    </div>
<div class="col-xs-12 col-sm-4 col-md-4" >
    <ngb-carousel>
        <ng-template ngbSlide>
            <img src="/assets/1.png" alt="1" class="d-block w-100">
        </ng-template>
        <ng-template ngbSlide>
            <img src="/assets/2.png" alt="2" class="d-block w-100">
        </ng-template>
        <ng-template ngbSlide>
            <img src="/assets/3.png" alt="3" class="d-block w-100">
        </ng-template>
        <ng-template ngbSlide>
            <img src="/assets/4.png" alt="4" class="d-block w-100">
        </ng-template>
    </ngb-carousel>
</div>




